import { TierConsumerStoreSlice } from './types';
import { tierConsumerReduxKey } from './constants';

function getState(state: any): TierConsumerStoreSlice {
  if (!state[tierConsumerReduxKey]) {
    return {} as any;
  }
  return state[tierConsumerReduxKey];
}

export const isConsumerReduxReady = state => getState(state).reduxReady;

export const isMatureFilterOverridden = (state, deviationId) =>
  getState(state).matureFilterOverrides &&
  getState(state).matureFilterOverrides.includes(deviationId);
